import React from 'react';
import classNames from 'classnames';

import css from './IconGift.module.css';

const IconGift = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Cagnotte fidélité"
    >
      {/* Box bottom */}
      <path
        d="M3 12H21V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V12Z"
        fill="currentColor"
        opacity="0.25"
      />
      {/* Ribbon vertical */}
      <path d="M11 12H13V22H11V12Z" fill="currentColor" />
      {/* Box top / lid */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 8C2 6.89543 2.89543 6 4 6H20C21.1046 6 22 6.89543 22 8V12H2V8ZM11 8H13V10H11V8Z"
        fill="currentColor"
        opacity="0.6"
      />
      {/* Ribbon horizontal on lid */}
      <path d="M11 6H13V12H11V6Z" fill="currentColor" />
      {/* Left bow loop */}
      <path
        d="M12 6C12 6 9 5.5 7.5 4C6.5 3 7 2 8 2C9.5 2 11 4 12 6Z"
        fill="currentColor"
      />
      {/* Right bow loop */}
      <path
        d="M12 6C12 6 15 5.5 16.5 4C17.5 3 17 2 16 2C14.5 2 13 4 12 6Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconGift;
